import { get } from 'global/lib/lodash';

export const PDF_POLL_INTERVAL_MS = 5000;
export const PDF_POLL_TIMEOUT_MS = 3 * 60 * 1000;

export const messageShareUrl = (message) => get(message, 'shareUrl') || get(message, 'share_url') || null;

// Trade-specific task PDFs are extra media on the same message. The share page
// waits for the matching file when this query param is present.
export const shareUrlForTrade = (shareUrl, tradeTypeId) => {
  if (!shareUrl) return null;
  if (tradeTypeId == null || tradeTypeId === '' || tradeTypeId === 'all') return shareUrl;
  const join = shareUrl.includes('?') ? '&' : '?';
  return `${shareUrl}${join}tradeTypeId=${encodeURIComponent(tradeTypeId)}`;
};

const tradeTypeIdOf = (media) => {
  const id = get(media, 'customProperties.tradeTypeId', get(media, 'customProperties.trade_type_id'));
  return id == null || id === '' ? null : String(id);
};

const tradeTypeOf = (media) => get(media, 'customProperties.tradeType', get(media, 'customProperties.trade_type', null));

export const mediaFileUrl = (media) => get(media, 'full7DayUrl') || get(media, 'fullUrl') || get(media, 'url') || null;

// Prefer the combined "all" PDF, then an untagged file (assessment score PDFs),
// then the first attachment. A tradeTypeId waits until that exact file exists.
export const pdfUrlFromMedia = (mediaList, tradeTypeId) => {
  const list = (Array.isArray(mediaList) ? mediaList : []).filter(Boolean);
  if (!list.length) return null;

  if (tradeTypeId && tradeTypeId !== 'all') {
    const match = list.find((media) => tradeTypeIdOf(media) === String(tradeTypeId));
    return match ? mediaFileUrl(match) : null;
  }

  const all = list.find((media) => tradeTypeOf(media) === 'all');
  if (all && mediaFileUrl(all)) return mediaFileUrl(all);

  const untagged = list.find((media) => !tradeTypeOf(media));
  if (untagged && mediaFileUrl(untagged)) return mediaFileUrl(untagged);

  return mediaFileUrl(list[0]);
};

// Link to hand to copy/email/open. share_url is ready before the PDF exists.
// Fall back to media URLs when an older API still returns the file inline.
export const linkForMessage = (message, tradeTypeId) => {
  const shareUrl = messageShareUrl(message);
  if (shareUrl) return shareUrlForTrade(shareUrl, tradeTypeId);

  const list = get(message, 'media', []);
  const media = Array.isArray(list) ? list.filter(Boolean) : [];
  return mediaFileUrl(media[media.length - 1]) || mediaFileUrl(media[0]);
};
